export default "__VITE_ASSET__DSOyZp7v__"